import _objectSpread from "/home/clearis/Desktop/supplynet/site/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/clearis/Desktop/supplynet/site/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/home/clearis/Desktop/supplynet/site/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { brazil } from './countries';

function makeResult(vat, isValid, country) {
  return {
    value: vat || undefined,
    isValid: Boolean(isValid),
    isValidFormat: country ? isVatValidToRegexp(vat, country.rules.regex).isValid : false,
    isSupportedCountry: Boolean(country),
    country: !country ? undefined : {
      name: country.name,
      isoCode: {
        short: country.codes[0],
        long: country.codes[1],
        numeric: country.codes[2]
      }
    }
  };
}

function removeExtraChars() {
  var vat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return vat.toString().toUpperCase().replace(/(\s|-|\.|\/)+/g, '');
}

function getCountryCodes(country) {
  return [].concat(_toConsumableArray(country.codes), [country.name === 'Greece' ? 'EL' : undefined]).filter(Boolean);
}

var countriesVATDoesNotStartWithCountryCode = [brazil.name];

function isVATStartWithCountryCode(countryName) {
  return !countriesVATDoesNotStartWithCountryCode.includes(countryName);
}

function isVATStartWithNumber(vat) {
  return !!vat.match(/^\d{2}/);
}

function getCountry(vat, countriesList) {
  var _iterator = _createForOfIteratorHelper(countriesList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var country = _step.value;

      if (startsWithCode(vat, country) || !isVATStartWithCountryCode(country.name) && isVATStartWithNumber(vat)) {
        return _objectSpread({}, country);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return undefined;
}

function startsWithCode(vat, country) {
  var countryCodes = getCountryCodes(country);
  return countryCodes.filter(function (code) {
    return vat.startsWith(code);
  }).length > 0;
}

function isVatValidToRegexp(vat, regexArr) {
  var _iterator2 = _createForOfIteratorHelper(regexArr),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var regex = _step2.value;
      var isValid = regex.test(vat);
      if (isValid) return {
        isValid: true,
        regex: regex
      };
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return {
    isValid: false,
    regex: undefined
  };
}

function isVatValid(vat, country) {
  var regexpValidRes = isVatValidToRegexp(vat, country.rules.regex);
  if (!regexpValidRes.isValid || !regexpValidRes.regex) return false;
  var regexResult = regexpValidRes.regex.exec(vat);
  if (!regexResult) return false;
  return country.calcFn(regexResult[2]);
}

export function checkVAT(vat) {
  var countriesList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!vat) return makeResult(vat, false);
  var cleanVAT = removeExtraChars(vat);
  var country = getCountry(cleanVAT, countriesList);
  var isValid = country ? isVatValid(cleanVAT, country) : false;
  return makeResult(cleanVAT, isValid, country);
}